export default "__VITE_ASSET__CVF$7qSF__"